import React from "react";
import { Flex, Typography, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const AppFooter: React.FC = () => {
  const screens = useBreakpoint();

  // Don't render footer on mobile devices (screens < 768px)
  if (!screens.md && !screens.lg && !screens.xl && !screens.xxl) {
    return null;
  }

  // Don't render footer if URL contains /pre-load
  if (window.location.pathname.includes("/pre-load")) {
    return null;
  }

  return (
    <Footer className="container__footer">
      <Flex align="center" justify="space-between" wrap>
        <Typography.Text type="secondary" className="container__footer-text">
          {`©  ${new Date().getFullYear()}`}{" "}
          <Typography.Link
            href="https://www.qualifyme.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            QualifyMe.ai
          </Typography.Link>{" "}
          | All Rights Reserved.
        </Typography.Text>
        <Space align="center" size={16} className="container__footer-links">
          <Typography.Link
            href="https://www.qualifyme.ai/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="container__footer-text"
          >
            Terms & Conditions
          </Typography.Link>
          <Typography.Link
            href="https://www.qualifyme.ai/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="container__footer-text"
          >
            Privacy Policy
          </Typography.Link>
          <Typography.Link
            href="https://www.qualifyme.ai/refund"
            target="_blank"
            rel="noopener noreferrer"
            className="container__footer-text"
          >
            Refund Policy
          </Typography.Link>
        </Space>
      </Flex>
    </Footer>
  );
};

export default AppFooter;
